import $ from 'jquery';

// Handler delegowany na document przeżywa podmianę DOM przy wire:navigate -
// wiązanie bezpośrednio na .sidebar-toggle ginęłoby po nawigacji Livewire.
$(document).on("click touch", ".sidebar-toggle", function () {
  $(".sidebar").toggleClass("toggled");
});

// Po wire:navigate DOM sidebara jest nowy, a DOMContentLoaded nie odpala się
// ponownie - dlatego rozwinięcie aktywnej grupy podpinamy też pod livewire:navigated.
function expandActiveSidebarGroup() {
  const active = $(".sidebar .active");

  if (active.length && active.parent(".collapse").length) {
    const parent = active.parent(".collapse");

    parent.prev("a").attr("aria-expanded", true);
    parent.addClass("show");
  }
}

document.addEventListener("DOMContentLoaded", expandActiveSidebarGroup);
document.addEventListener("livewire:navigated", expandActiveSidebarGroup);
